/**
 * Tracking utilities for GTM and analytics
 */

declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Push an event to GTM dataLayer
 */
export const pushToDataLayer = (event: string, data?: Record<string, any>) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event,
    ...data,
  });
};

/**
 * Track sign up event
 * Uses Meta Pixel standard event name: CompleteRegistration
 */
export const trackSignUp = (data?: { email?: string; method?: string }) => {
  pushToDataLayer('CompleteRegistration', data);
};

/**
 * Track start trial event
 * Uses Meta Pixel standard event name: StartTrial
 * https://developers.facebook.com/docs/meta-pixel/reference#standard-events
 */
export const trackStartTrial = (data?: {
  plan?: string;
  term?: string;
  trialLabel?: string;
  value?: number;
  currency?: string;
  predicted_ltv?: number;
}) => {
  pushToDataLayer('StartTrial', {
    ...data,
    value: data?.value || 0,
    currency: data?.currency || 'USD',
    predicted_ltv: data?.predicted_ltv || 0,
  });
};

/**
 * Track purchase/subscription event
 */
export const trackPurchaseTrial = (data?: {
  plan?: string;
  term?: string;
  totalAmount?: number;
  trialLabel?: string;
}) => {
  pushToDataLayer('purchase_trial', data);
};

/**
 * Track trial cancellation event
 * Fires when a user successfully cancels their trial subscription
 */
export const trackCancelTrial = (data?: {
  plan?: string;
  term?: string;
  cancelAt?: string;
}) => {
  pushToDataLayer('trial_cancelled', data);
};

/**
 * Track paid subscription cancellation event
 * Fires when a user successfully cancels their paid subscription
 */
export const trackCancelSubscription = (data?: {
  plan?: string;
  term?: string;
  cancelAt?: string;
  reason?: string;
}) => {
  pushToDataLayer('subscription_cancelled', data);
};
